import { Listing } from "../types";
import nhsdDirectorySearch from "./nhsdDirectorySearch";

type ParamKeys = "latitude" | "longitude" | "name" | "postcode";
type ProviderDirectorySearchParams = Partial<Record<ParamKeys, string>>;

export type ProviderDirectorySearchArgs = {
  params: ProviderDirectorySearchParams;
  searchService?: (
    params: ProviderDirectorySearchParams
  ) => Promise<Array<Listing>>;
};

const providerDirectorySearch = async ({
  params,
  searchService = nhsdDirectorySearch,
}: ProviderDirectorySearchArgs) => {
  return await searchService(params);
};

export default providerDirectorySearch;
